enum PollutionType {
  waste = 'waste',
  co2 = 'co2',
  water = 'water',
}

export default PollutionType;
